export const buttons = {
  mySuccess: "Мне повезет!",
  continue: "Продолжить",
  confirm: "Подтвердить",
  resend: "Отправить повторно",
  send2Email: "Отправить на email",
  cancel: "Отмена",
  delete: "Удалить",
  deactivate: "Деактивировать",
  activate: "Активировать",
};
